// 9fbef606107a605d69c0edbcd8029e5d
import { addToCartEcom } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import {
  getFavoriteStoreActn,
  resetStoresByCoordinates,
} from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import {
  getPromotionsData,
  getServerTimeFromState,
} from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import { loadLayoutData } from '@tcp/core/src/reduxStore/actions';
import {
  getCurrencyAttributes,
  getCurrentCurrency,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getABTestForStickyFilter,
  getABTestIsSearchEnhancementRedesignEnabled,
  getABTestIsShowPriceRange,
  getIsBestSellerBadgeEnabledSLP,
  getIsBIABagPageCustomVariableEnabled,
  getIsBopisFilterEnabled,
  getIsBrierleyPromoEnabled,
  getIsBundleTrackerEnabled,
  getIsDidYouMeanEnabled,
  getIsDynamicBadgeEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
  getFadeImageHoverEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getIsInternationalShipping,
  getIsKeepAliveProduct,
  getAbTestIsMostFavoritedBackAbEnabled,
  getIsNewPlpImageBorderEnabled,
  getIsNewSwatchURLEnabled,
  getIsNonInvSessionFlag,
  getIsOneClickATCEnabled,
  getIsPaginationViewEnabled,
  getIsPLPImageHeightBasedOnAspectRatio,
  getIsPlpPdpAnchoringEnabled,
  getIsShowBrandNameEnabled,
  getIsShowPriceRange,
  getIsSizeGroupFilterEnabled,
  getIsSlpDesktopView,
  getIsSLPPersistEnabled,
  getIsSyteEnabled,
  getIsTopRatedBadgeEnabledSLP,
  getSortByRatingLabel,
  isShopThisStoreModeOn,
  getABTestSetPLPSLPAddToCartCTA,
  getIsCustomerRatingFilterWebEnabled,
  getIsInfluencerBadgeEnabledForListingPages,
  getisRatingRedesignAbTest,
  getIsPromotionRedesignAbTest,
  getTileRedesignAB,
  getInfluencerPicksEnabled,
  getIsGuestFavEnabled,
  getIsOneHrFilterEnabled,
  getIsHeaderScrollViewDisabled,
  getIsRedesignGlobalHeaderEnabled,
  getIsSLPNewTileImplementationEnabled,
  getIsUpdatedPromotionsDisplayEnabled,
  getTopRatedAttributeToBeChecked,
  getBestSellerAttributeToBeChecked,
  getMostFavoritedAttributeToBeChecked,
  getIsBuyMorePromoEnabled,
  getIsAlternateImageOnHoverEnabled,
  getPLPImageSizeConfig,
  getIsDynamicColorSwatchesEnabled,
  getIsHoverToPreviewColorSwatchesEnabled,
  getIsInteractiveColorSwatchBandEnabled,
  getIsFourTileGridEnabled,
  getTsSwatchColorUrlEnabled,
  getIsHoverToRevealATBButtonEnabled,
  getIsClickableBrandBadgesEnabled,
  getIsFinalSaleBackABEnabled,
  getIsRandomBgColorEnabled,
  getIsTransparentImageSizeReduced,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import utils from '@tcp/core/src/utils';
import { change, getFormValues, initialize } from 'redux-form';
import { setSlpProductData } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions';
import { setClickAnalyticsData, trackClick, trackPageView } from '../../../../../analytics/actions';
import {
  getPageName,
  getPageSection,
  getPageSubSection,
} from '../../../../common/organisms/PickupStoreModal/molecules/PickupStoreSelectionForm/container/PickupStoreSelectionForm.selectors';
import {
  openQuickViewWithValues,
  setSlpDataForQuickView,
} from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getDefaultFavStore,
  getDefaultStoreData,
  getUserLoggedInState,
  isPlccUser,
  isRememberedUser,
} from '../../../account/User/container/User.selectors';
import { getBuyItAgainBagPageProducts } from '../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import {
  addItemsToWishlist,
  getUserFavt,
  removeAddToFavoriteErrorState,
  setLastDeletedItemIdAction,
  showToastModal,
} from '../../Favorites/container/Favorites.actions';
import {
  fetchAddToFavoriteErrorMsg,
  fetchErrorMessages,
  getDefaultFavItemInProgressFlag,
  wishListFromState,
  getToastModalState,
  selectDefaultWishlistId,
} from '../../Favorites/container/Favorites.selectors';
import { getNavTree } from '../../ProductDetail/container/ProductDetail.selectors';
import { setBopisFilterState } from '../../ProductListing/container/ProductListing.actions';
import {
  getCategoryId,
  getCurrentListingName,
  getIsHeaderSticky,
  getIsHidePLPAddToBag,
  getIsHidePLPRatings,
  getLastLoadedPageNumber,
  getLongDescription,
  getOnModelImageAbTestPlp,
  getUnbxdId,
} from '../../ProductListing/container/ProductListing.selectors';
import {
  checkPromoCondition,
  getProductsAndTitleBlocks,
} from '../../ProductListing/container/ProductListing.util';
import submitProductListingFiltersForm from '../../ProductListing/container/productListingOnSubmitHandler';
import {
  getL1Categories,
  getL2Categories as getL2GroupingCategories,
  setL1CategorySelection as setL1CategoryFilterSelection,
  setL1CategorySelectionLoaded,
  setL2CategorySelection as setL2CategoryGroupingSelection,
  setL2CategorySelectionLoaded as setL2CategoryGroupingSelectionLoaded,
  setSelectedL1CategoryContent,
  setSelectedL2CategoryGroupID,
} from '../../ShopThisStore/container/ShopThisStore.actions';
import {
  getShopThisStoreL1categories,
  getShopThisStoreL1categoryLoading,
  getShopThisStoreL1categorySelection,
  getShopThisStoreL1categorySelectionLoaded,
  getShopThisStoreL2categories,
  getShopThisStoreL2CategoryGroupingSelection,
  getShopThisStoreL2CategoryGroupingSelectionLoaded,
  getShopThisStoreL2categoryLoading,
} from '../../ShopThisStore/container/ShopThisStore.selectors';
import {
  didYouMeanNullSearchRedirect,
  getMoreSlpProducts,
  getSlpPaginatedProducts,
  getSlpProducts,
  resetSlpProducts,
  setSlpLoadingState,
  setSlpScrollState,
} from './SearchDetail.actions';
import {
  checkIfSearchResultsAvailable,
  getAlternateBrandApiCalled,
  getAlternateBrandName,
  getAlternateBrandsShowns,
  getAppliedFilterIds,
  getCrossBrandProducts,
  getCurrentSearchForText,
  getInitialFilterValues,
  getIsBopisFilterOn,
  getIsLoadingMore,
  getIsSearchPage,
  getLoadedProductsCount,
  getLoadedProductsPages,
  getPlpCrossPromo,
  getPLPGridPromos,
  getPlpHorizontalPromo,
  getProductsFilters,
  getProductsSelect,
  getSelectedPage,
  getShouldSlpScroll,
  getSLPTopPromos,
  getSlpUrl,
  getTotalProductsCount,
} from './SearchDetail.selectors';

import { getProductsPerPageCount } from './SearchDetail.util';

const FILTER_FORM = 'filter-form';

export function mapStateToProps(state) {
  const productBlocks = getLoadedProductsPages(state);
  const { filtersLength, filterCount } = getAppliedFilterIds(state);
  const plpHorizontalPromos = getPlpHorizontalPromo(state);
  const plpGridPromos = getPLPGridPromos(state);
  const plpCrossPromos = getPlpCrossPromo(state);
  const { showInGridPromos } = utils.getABtestFromState(state.AbTest);
  const isPromoApplied = checkPromoCondition({
    filterCount,
    plpHorizontalPromos,
    plpGridPromos,
    inGridPlp: {},
    inMultiGridPlp: {},
    showInGridPromos,
    plpCrossPromos,
  });
  return {
    apiConfig: state.APIConfig,
    productsBlock: isPromoApplied
      ? getProductsAndTitleBlocks(
          state,
          productBlocks,
          plpGridPromos,
          plpHorizontalPromos,
          plpCrossPromos,
          5,
          filterCount
        )
      : productBlocks,
    filterCount,
    isBopisFilterEnabled: getIsBopisFilterEnabled(state),
    products: getProductsSelect(state),
    isSLPNewTileImplementationEnabled: getIsSLPNewTileImplementationEnabled(state),
    filters: getProductsFilters(state),
    categoryId: getCategoryId(state),
    loadedProductCount: getLoadedProductsCount(state),
    unbxdId: getUnbxdId(state),
    totalProductsCount: getTotalProductsCount(state),
    productLimitPerPage: getProductsPerPageCount(state),
    // navTree: getNavigationTree(state),
    navTree: getNavTree(state),
    navigationData: state.Navigation && state.Navigation.navigationData,
    searchedText: isShopThisStoreModeOn()
      ? getCurrentSearchForText(state)?.split('?')[0]
      : getCurrentSearchForText(state),
    filtersLength,
    initialValues: getInitialFilterValues(state),
    longDescription: getLongDescription(state),
    isLoadingMore: getIsLoadingMore(state),
    selectedPage: getSelectedPage(state),
    isSearchResultsAvailable: checkIfSearchResultsAvailable(state),
    isBrierleyPromoEnabled: getIsBrierleyPromoEnabled(state),
    lastLoadedPageNumber: getLastLoadedPageNumber(state),
    formValues: getFormValues(FILTER_FORM)(state),
    onSubmit: submitProductListingFiltersForm,
    currentNavIds: state.ProductListing && state.ProductListing.currentNavigationIds,
    searchResultSuggestions:
      state.SearchListingPage && state.SearchListingPage.searchResultSuggestions,
    initialSearchTerm: state.SearchListingPage && state.SearchListingPage.initialSearchTerm,
    oldSearchResultSuggestions:
      state.SearchListingPage && state.SearchListingPage.oldSearchResultSuggestions,
    searchResultKeywordSuggestions: state?.Search?.searchResults?.autosuggestList?.[0]?.suggestions,
    slpPersistSearchTerm: state?.Search?.searchResults?.autosuggestList?.[0]?.searchTerm,
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    isLoggedIn: getUserLoggedInState(state) && !isRememberedUser(state),
    deviceType: state.DeviceInfo && state.DeviceInfo.deviceType,
    isKeepAliveEnabled: getIsKeepAliveProduct(state),
    AddToFavoriteErrorMsg: fetchAddToFavoriteErrorMsg(state),
    pageNameProp: getPageName(state),
    pageSectionProp: getPageSection(state),
    pageSubSectionProp: getPageSubSection(state),
    isSearchPage: getIsSearchPage(state),
    errorMessages: fetchErrorMessages(state),
    isInternationalShipping: getIsInternationalShipping(state),
    isOnModelAbTestPlp: getOnModelImageAbTestPlp(state),
    slpUrl: getSlpUrl(state),
    defaultWishListFromState: wishListFromState(state),
    isShowPriceRangeKillSwitch: getIsShowPriceRange(state),
    isNewPLPAtbCardTileEnabled: false,
    isNewPLPImageBorderEnabled: getIsNewPlpImageBorderEnabled(state),
    isHidePLPAddToBag: getIsHidePLPAddToBag(state),
    isHidePLPRatings: getIsHidePLPRatings(state),
    showPriceRangeForABTest: getABTestIsShowPriceRange(state),
    isPlcc: isPlccUser(state),
    searchTopPromos: getSLPTopPromos(state),
    deleteFavItemInProgressFlag: getDefaultFavItemInProgressFlag(state),
    shouldSlpScrollState: getShouldSlpScroll(state),
    isPlpPdpAnchoringEnabled: getIsPlpPdpAnchoringEnabled(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    isFadeImageHoverEnabled: getFadeImageHoverEnabled(state),
    isABTestForStickyFilter: getABTestForStickyFilter(state),
    isNonInvSessionFlag: getIsNonInvSessionFlag(state),
    isShowBrandNameEnabled: getIsShowBrandNameEnabled(state),
    isPromoApplied,
    alternateBrand: getAlternateBrandName(state),
    isBopisFilterOn: getIsBopisFilterOn(state),
    favStore: getDefaultStoreData(state),
    defaultStore: getDefaultFavStore(state),
    isBundleTrackerEnabled: getIsBundleTrackerEnabled(state),
    isPaginationViewEnabled: getIsPaginationViewEnabled(state),
    isSLPExtendedView: getIsSlpDesktopView(state),
    currentListingName: getCurrentListingName(state),
    isSlpPersistEnabled: getIsSLPPersistEnabled(state),
    isDidYouMeanEnabled: getIsDidYouMeanEnabled(state),
    isHeaderSticky: getIsHeaderSticky(state),
    isSearchEnhancementRedesignEnabled: getABTestIsSearchEnhancementRedesignEnabled(state),
    isPLPImageHeightBasedOnAspectRatio: getIsPLPImageHeightBasedOnAspectRatio(state),
    isSyteEnabled: getIsSyteEnabled(state),
    acrossBrandApiCalled: getAlternateBrandApiCalled(state),
    crossBrandProducts: getCrossBrandProducts(state),
    alternateBrandsShown: getAlternateBrandsShowns(state),
    isNewSwatchUrlEnabled: getIsNewSwatchURLEnabled(state),
    isSizeGroupFilterEnabled: getIsSizeGroupFilterEnabled(state),
    shopThisStoreL1categories: getShopThisStoreL1categories(state)?.filter(
      (item) => typeof item === 'string'
    ),
    shopThisStoreL2categories: getShopThisStoreL2categories(state)?.filter(
      (item) => typeof item === 'string'
    ),
    shopThisStoreL1categorySelection: getShopThisStoreL1categorySelection(state),
    shopThisStoreL1categorySelectionLoaded: getShopThisStoreL1categorySelectionLoaded(state),
    shopThisStoreL2CategoryGroupingSelection: getShopThisStoreL2CategoryGroupingSelection(state),
    shopThisStoreL2CategoryGroupingSelectionLoaded:
      getShopThisStoreL2CategoryGroupingSelectionLoaded(state),
    isShopThisStoreL1categoriesLoading: getShopThisStoreL1categoryLoading(state),
    isShopThisStoreL2categoriesLoading: getShopThisStoreL2categoryLoading(state),
    sortByRatingLabel: getSortByRatingLabel(state),
    isTopRatedBadgeEnabledSLP: getIsTopRatedBadgeEnabledSLP(state),
    isBestSellerBadgeEnabledSLP: getIsBestSellerBadgeEnabledSLP(state),
    isOneClickATCEnabled: getIsOneClickATCEnabled(state),
    isUserLoggedIn: getUserLoggedInState(state),
    isBIAABCustomVariableEnabled: getIsBIABagPageCustomVariableEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isMostFavoritedBadgeEnabled: getAbTestIsMostFavoritedBackAbEnabled(state),
    setPLPSLPAddToCartCTA: getABTestSetPLPSLPAddToCartCTA(state),
    isCustomerRatingFilterWebEnabled: getIsCustomerRatingFilterWebEnabled(state),
    isInfluencerBadgeEnabled: getIsInfluencerBadgeEnabledForListingPages(state),
    isRatingRedesignAbTest: getisRatingRedesignAbTest(state),
    isPromotionMessageAB: getIsPromotionRedesignAbTest(state),
    isTileRedesignAB: getTileRedesignAB(state),
    isInfluencerPicksEnabled: getInfluencerPicksEnabled(state),
    isGuestFavEnabled: getIsGuestFavEnabled(state),
    toastModalState: getToastModalState(state),
    defaultWishlistId: selectDefaultWishlistId(state),
    isOneHrFilterEnabled: getIsOneHrFilterEnabled(state),
    isHeaderScrollViewDisabled: getIsHeaderScrollViewDisabled(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
    promotionsData: getPromotionsData(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    topRatedAttributeSLP: getTopRatedAttributeToBeChecked(state),
    bestSellerAttributeSLP: getBestSellerAttributeToBeChecked(state),
    mostFavoritedAttributeSLP: getMostFavoritedAttributeToBeChecked(state),
    serverTime: getServerTimeFromState(state),
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    isAlternateImageOnHoverEnabled: getIsAlternateImageOnHoverEnabled(state),
    imageConfigWithoutDPR: getPLPImageSizeConfig(state),
    isDynamicColorSwatchesEnabled: getIsDynamicColorSwatchesEnabled(state),
    isHoverToPreviewColorSwatchesEnabled: getIsHoverToPreviewColorSwatchesEnabled(state),
    isInteractiveColorSwatchBandEnabled: getIsInteractiveColorSwatchBandEnabled(state),
    isFourTileGridEnabled: getIsFourTileGridEnabled(state),
    isSwatchAsColorUrlEnabled: getTsSwatchColorUrlEnabled(state),
    isHoverToRevealATBButtonEnabled: getIsHoverToRevealATBButtonEnabled(state),
    isFeatureBrandEnabled: getIsClickableBrandBadgesEnabled(state),
    isFinalSaleABEnabled: getIsFinalSaleBackABEnabled(state),
    isRandomBgColorEnabled: getIsRandomBgColorEnabled(state),
    isTransparentImageSizeReduceEnabled: getIsTransparentImageSizeReduced(state),
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    getProducts: (payload) => {
      dispatch(getSlpProducts(payload));
    },
    didYouMeanNullSearch: (payload) => {
      dispatch(didYouMeanNullSearchRedirect(payload));
    },
    onFavtLoad: (payload) => {
      dispatch(getUserFavt(payload));
    },
    getMoreProducts: (payload) => {
      dispatch(getMoreSlpProducts(payload));
    },
    getPaginatedProducts: (payload) => {
      dispatch(getSlpPaginatedProducts(payload));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    onAddItemToFavorites: (payload) => {
      dispatch(addItemsToWishlist(payload));
    },
    removeAddToFavoritesErrorMsg: (payload) => {
      dispatch(removeAddToFavoriteErrorState(payload));
    },
    resetProducts: () => {
      dispatch(resetSlpProducts());
    },
    onSetLastDeletedItemIdAction: (payload) => {
      dispatch(setLastDeletedItemIdAction(payload));
    },
    resetSlpScrollState: () => {
      dispatch(setSlpScrollState(false));
    },
    resetSlpLoadingState: (payload) => {
      dispatch(setSlpLoadingState(payload));
    },
    updateFormValue: (field, value) => {
      dispatch(change(FILTER_FORM, field, value));
    },
    resetFormValue: () => {
      dispatch(initialize(FILTER_FORM, { sort: '' }));
    },
    setBopisFilterStateActn: (payload) => {
      dispatch(setBopisFilterState(payload));
    },
    trackAnalyticsClick: (payload, eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    trackClickPromotion: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    trackPageLoad: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      const timer = setTimeout(() => {
        dispatch(
          trackPageView({
            props: {
              initialProps: {
                pageProps: {
                  pageData: {
                    ...payload,
                  },
                },
              },
            },
          })
        );
        const analyticsTimer = setTimeout(() => {
          dispatch(setClickAnalyticsData({}));
          clearTimeout(analyticsTimer);
        }, 200);
        clearTimeout(timer);
      }, 100);
    },
    clearPromoDataOnRouteChange: () => {
      dispatch(loadLayoutData({}, 'productListingPage'));
    },
    resetSuggestedStores: (payload) => dispatch(resetStoresByCoordinates(payload)),
    getFavoriteStoreById: (payload) => dispatch(getFavoriteStoreActn(payload)),
    trackWishListClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
    },
    trackClickAnalyticsBopisFilter: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    getL1CategoriesActn: (payload) => {
      dispatch(getL1Categories(payload));
    },
    setL1CategorySelection: (payload) => {
      dispatch(setL1CategoryFilterSelection(payload));
    },
    setL1CategorySelectionLoaded: (payload) => {
      dispatch(setL1CategorySelectionLoaded(payload));
    },
    setL2CategorySelection: (payload) => {
      dispatch(setL2CategoryGroupingSelection(payload));
    },
    getL2Categories: (storeId, categoryFilter) => {
      dispatch(getL2GroupingCategories(storeId, categoryFilter));
    },
    setL1CategorySelectionCategoryContent: (selectedCategory) => {
      dispatch(setSelectedL1CategoryContent(selectedCategory));
    },
    setL2CategorySelectionCategoryGroupId: (selectedGroupId) => {
      dispatch(setSelectedL2CategoryGroupID(selectedGroupId));
    },
    setL2CategorySelectionLoaded: (payload) => {
      dispatch(setL2CategoryGroupingSelectionLoaded(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    showToastModalAction: (payload) => {
      dispatch(showToastModal(payload));
    },
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
    saveProductDataForQV: (payload) => {
      dispatch(setSlpDataForQuickView(payload));
    },
    saveProductDataForPdp: (payload) => {
      dispatch(setSlpProductData(payload));
    },
  };
}
